module.exports = __webpack_public_path__ + "img/file_type_x.491e9fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/AISmart/file_type_x.png
// module id = p7NH
// module chunks = 12 13 14 17 26